<!--
 * @Author: your name
 * @Date: 2020-08-28 11:55:14
 * @LastEditTime: 2020-09-30 15:22:34
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fontend_old_wap\src\components\subject.vue
-->
<template>
  <div class="onlyimg">
    <div @click="typego(zhuanti.url, zhuanti.url_type, zhuanti.clas_id)" class="warp">
      <img :src="zhuanti.image == null ? '/static/errorimg1.png' : zhuanti.image" />
      <div class="ellipse">
        <div class="ellipse-col">
          <span class="title">{{ zhuanti.name }}</span>
          <span class="ft12 col-999 title-f">{{ zhuanti.subheading }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "onlyimg",
  props: {
    zhuanti: {}
  },
  data() {
    return {};
  },
  methods: {
    getdatas() {},
    typego(url, type, clas_id) {
      if (type == 1) {
        //外部链接
        var arr = url.split("?");
        var BLHuser = localStorage.getItem("BLHuser");
        var mallid = localStorage.getItem("mallid");
        //判断是不是活动系统
        if (arr[0] == "http://www.system.fensaas.com") {
          var code = arr[1].split("=");
          if (!BLHuser) {
            this.$dialog
              .confirm({
                title: "提示 ",
                message: "您还未登录是否去登录？"
              })
              .then(() => {
                this.$router.push({ name: "NoteLogin" });
              })
              .catch(() => {});
            return false;
          }
          this.$api.get(
            "/movable/auth/member",
            { id_example: mallid, token_user: BLHuser, code: code[1] },
            res => {
              if (res.data.code == 1) {
                window.location.href =
                  res.data.data.web_url + "?token=" + res.data.data.token;
              } else if (res.data.code == 201) {
                this.$dialog
                  .confirm({
                    title: "提示 ",
                    message: "您还未登录是否去登录？"
                  })
                  .then(() => {
                    this.$router.push({ name: "NoteLogin" });
                  })
                  .catch(() => {});
              } else {
                this.$toast(res.data.message);
              }
            }
          );
        } else {
          window.location.href = url;
        }
      } else {
        //内部链接
        this.$router.push({
          path: "/goodsList",
          query: { id: clas_id, stype: 1 }
        });
      }
    }
  },
  created() {}
};
</script>
<style lang="less" scoped>
.onlyimg {
  width: calc(100% - 0.4rem);
  height: 2.82rem;
  background: #ffffff;
  margin: 0 auto;
  border-radius: 0.16rem;
  overflow: hidden;

  .warp {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    img {
      width: 100%;
      height: 2.08rem;
      // object-fit: cover;
    }

    .ellipse {
      width: 100%;
      height: 100%;
      padding-top: 0.1rem;

      .ellipse-col {
        display: flex;
        align-items: flex-end;
      }

      .title {
        font-size: 0.32rem;
        font-weight: bold;
        color: #262626;
        line-height: 0.44rem;
        margin-left: 0.2rem;
      }

      .title-f {
        font-size: 0.24rem;
        font-weight: 400;
        color: rgba(38, 38, 38, 0.5);
        line-height: 0.32rem;
        margin-left: 0.16rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subject.vue